import React, { useState } from "react";
import { Box, Flex, HStack, Heading, Image, Button, Text} from '@chakra-ui/react';
import ReviewFeedbackIcon from "../Images/ReviewFeedbackIcon.svg";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BASE_API_URL } from './config';
import DotsLoading from "./DotsLoading"; 
import { a } from "./appColors";
import { formatExamBoard } from "./examBoards";

import SeperatorIcon from "../Images/seperatorIcon.svg";
import CardArrow from "../Images/Paper-card-arrow.svg";


const CreateUserAttempt = ({ subjectName, paperName, numOfQuestionsLeft, mark, grade, totalMark, inProgress, progressPercentage, user_paper_attempt_guid, examBoardCode,
    qualificationCode, }) => {

    const [questions, setQuestions] = useState([]);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false); 
    const [onCardHover, setOnCardHover] = useState(false);

    const handleClick = () => {
        setLoading(true);

        setTimeout(() => {
        setLoading(false);
        }, 2000);
    };

  const handleHover = () => {
    setOnCardHover(true);
  };

    const handleAccessPaperAttempt = async (user_paper_attempt_guid) => {
        if (loading) return;
      
        try {
          setLoading(true);
          setError(null);
      
          const paperDetailResponse = await axios.get(
            `${BASE_API_URL}/api/v1/user-paper-attempts/detail/${user_paper_attempt_guid}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              },
            }
          );
      
          const { subject_name, paper_name, paper_code, time_hour, time_min, exam_board_code, exam_qualification_code } = paperDetailResponse.data;
          const formattedPaperName = `Paper ${paper_name.split(' ')[1]}${paper_code.trim().slice(-1)} ${paper_name.split(' ').slice(2).join(' ')}`;
      
          const questionsResponse = await axios.get(
            `${BASE_API_URL}/api/v1/user-paper-attempts/questions-with-attempt/${user_paper_attempt_guid}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
              },
            }
          );

          setQuestions(questionsResponse.data);

          navigate('/my-papers/solve-paper', {
            state: {
              questions: questionsResponse.data,
              paper_Guid: user_paper_attempt_guid,
              subject_name,
              formattedPaperName,
              time_hour,
              time_min,
            },
          });
        } catch (error) {
          console.error("Error fetching past paper questions or creating attempt:", error);
          setError("There was an error trying to access this paper. Please try again");
        } finally {
          setLoading(false);
        }
      };

    return (
        <Box
      width="284px"
      height="254px"
      flexShrink="0"
      borderRadius="8px"
      border="1px solid" borderColor={a.border}
      backgroundColor={a.surface}
      overflow="hidden"
      position ="relative"
      _hover={{ boxShadow: "0px 0px 15px 4px rgba(138, 138, 138, 0.15)" }}
      transition="box-shadow 0.2s ease"
      onClick = {()=>handleAccessPaperAttempt(user_paper_attempt_guid)}
    >
      <Box
        width="254px"
        height="134px"
        bg={a.surfaceSubtle} 
        borderRadius="8px" 
        mt = "14px"
        mx="auto"
        position="relative"
        cursor="pointer"
        
      >
        {inProgress ? (
          
          <Box
          position="absolute"
            top="8px"
            right="8px"
            display="flex"
            width="68px"
            height="15px"
            padding="4px"
            justifyContent="center"
            alignItems="center"
            gap="10px"
            flexShrink="0"
            borderRadius="34px" 
            background={a.accentSoft}
>
            <Text
            color={a.accent}
            fontSize="9px"
            fontWeight="500"
          >

            In Progress...
          </Text>
          </Box>
        ) : (
          <Box
            position="absolute"
            top="8px"
            right="8px"
            display="flex"
            width="68px"
            height="15px"
            padding="4px"
            justifyContent="center"
            alignItems="center"
            gap="10px"
            flexShrink="0"
            borderRadius="34px" 
            background={a.blue}
          >
            <Text color="#000000" fontSize="9px" fontWeight="500">
              Completed
            </Text>
          </Box>
        )}

        
        <Box mt="4px" position="absolute" bottom="12px" left="16px">
          <Flex
            mt="4px"
            alignItems="center"
            bg={a.surface}
            borderRadius="12px"
            maxWidth = "98px"
            px="8px"
            py="2px"
          >
            <Text color={a.text2} fontSize="11px" fontWeight="400">
              {formatExamBoard(examBoardCode)}
            </Text>
            <Box w="6px" h="6px" borderRadius="full" bg={a.accent} mx="5px" />
            <Text color={a.text2} fontSize="11px" fontWeight="400">
              {qualificationCode}
            </Text>
          </Flex>

          <Heading color={a.text} fontSize="14px" fontWeight="500" lineHeight="1.2">
            {subjectName}
          </Heading>

          
          <Text mt="4px" color={a.text} fontSize="12px" fontWeight="400" lineHeight="1.2">
            {paperName}
          </Text>
        </Box>
      </Box>

      <Box px="16px" mt="4px" mb="4px">
        {inProgress ? (
          <Flex mt="34px" justifyContent="space-between" alignItems="center">
            <Text color={a.textSub} fontSize="12px" fontWeight="400">
              {numOfQuestionsLeft} questions left
            </Text>
            <Flex alignItems="center" width="120px">
              <Box width="100%" height="5px" bg={a.border} borderRadius="24px" overflow="hidden">
                <Box
                  width={`${progressPercentage}%`}
                  height="5px"
                  bg={a.accent}
                  borderRadius="24px"
                />
              </Box>
              <Text color={a.textSub} fontSize="11px" fontWeight="400" ml="8px">
                {`${progressPercentage}%`}
              </Text>
            </Flex>
          </Flex>
        ) : (
          <HStack justifyContent="space-between" mt="16px">
            <Flex flexDirection="column">
              <Heading color={a.textSub} fontSize="12px" fontWeight="400">
                {`Mark: ${mark} / ${totalMark}`}
              </Heading>
              <Heading color={a.textSub} fontSize="12px" fontWeight="400">
                {`Grade: ${grade || "N/A"}`}
              </Heading>
            </Flex>
            <Flex flexDirection="row" alignItems="center">
              <Heading color={a.textSub} fontSize="12px" fontWeight="400" mr="8px">
                Review Feedback
              </Heading>
              <Button variant="unstyled">
                <Image className="app-nav-icon" src={ReviewFeedbackIcon} alt="reviewIcon" />
              </Button>
            </Flex>
          </HStack>
        )}
        {error && (
          <Text color="red" mt="4px" fontSize="12px">
            {error}
          </Text>
        )}
      </Box>
      <Button
      variant="unstyled"
      onClick = {()=>handleAccessPaperAttempt(user_paper_attempt_guid)}
      cursor="pointer"
      //_hover={{backgroundColor:"#F5F5F5",transform: "scale(1.05)"}}
      transition="all 0.2s ease-in-out"
      borderRadius="4px"
      bottom="2px" 
      right="16px" 
      position="absolute"
      
      >
        <Flex flexDirection="row" gap="4px"  alignItems="center">
          <Heading color={a.textSub} fontSize="11px" fontWeight="400"> Access Here</Heading>
          <Image className="app-nav-icon" src={CardArrow} alt="card-arrow-icon" boxSize = "25px" />
        </Flex>
      </Button>
    </Box>
  );
};

export default CreateUserAttempt; 
